<template>
  <button
    type="button"
    role="switch"
    class="kn-toggle"
    :class="{'is-on': value, 'is-disabled': disabled}"
    :aria-checked="value ? 'true' : 'false'"
    :aria-label="label"
    :disabled="disabled"
    @click="toggle"
  >
    <span class="kn-toggle__knob"></span>
  </button>
</template>

<script>
export default {
  name: "toggle-switch",
  props: {
    value: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    label: {type: String, default: null},
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      const newValue = !this.value;
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    },
  },
}
</script>

<style lang="scss">
.kn-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  width: 40px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: var(--kn-radius-pill);
  background-color: var(--kn-border-strong);
  cursor: pointer;
  transition: background-color .2s ease, box-shadow .2s ease;
  vertical-align: middle;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--kn-primary-ring);
  }

  &__knob {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(26, 26, 46, 0.25);
    transition: transform .2s ease;
  }

  &.is-on {
    background-color: var(--kn-primary);
  }

  &.is-on &__knob {
    transform: translateX(18px);
  }

  &.is-disabled {
    cursor: not-allowed;
    opacity: .5;
  }
}
</style>
